import React, { useCallback } from 'react'
import PropTypes from 'prop-types';
import { Select } from "antd";
const { Option } = Select;
const SelectInput = ({ onSearch, showSearch = true, allowClear = true, fieldName = "Option ...", defaultValue, value, optionFilterProp = "children", disabled = false, onChange, options, optionValue = "name", optionLabel = "name", multiple = false, required, label, customClass }) => {
    const requiredMark = required ? <span className="text-starColor">*</span> : null;

    const filterOption = useCallback((input, option) => {
        return (option?.value?.toLowerCase() ?? "").includes(input.toLowerCase()) || 
               option?.children?.toLowerCase().includes(input.toLowerCase());
    }, []);

    return (<div className='relative common-selector'>
        <label className={"as-label absolute z-10 left-0.5 -top-4 text-sm font-normal cust-input-label text-labelGrey"}>
            {label} {requiredMark}
        </label>
        <Select
            mode={multiple ? "multiple" : undefined}
            showSearch={showSearch}
            allowClear={allowClear}
            className={`${customClass} px-0 pt-2 pb-0 h-16  border-inputbordercolor dark:border-inputbordercolor focus:border-inputFocusedColor focus:shadow-none focus:outline-none focus-within:outline-none focus-visible:outline-none w-full rounded-none border-t-0 border-r-0 border-l-0 placeholder:text-placeholderGrey  focus:border-inputFocusedColor hover:border-inputFocusedColor dark:focus:border-inputFocusedColor`}
            defaultValue={defaultValue}
            value={value}
            placeholder={`Select ${fieldName}`}
            onSearch={onSearch}
            optionFilterProp={optionFilterProp}
            disabled={disabled}
            filterOption={filterOption}
            onChange={onChange}
        >
            {options?.map(option => (
                <Option key={option[optionValue]} value={option[optionValue]}>{option[optionLabel]}</Option>))}
        </Select>
    </div>
    )
}

SelectInput.propTypes = {
    showSearch: PropTypes.bool,
    allowClear: PropTypes.bool,
    fieldName: PropTypes.string,
    optionFilterProp: PropTypes.string,
    disabled: PropTypes.bool,
    options: PropTypes.array,
    optionValue: PropTypes.string,
    optionLabel: PropTypes.string,
    defaultValue: PropTypes.string,
    onChange: PropTypes.func
};

export default SelectInput